import { makeStyles, Theme } from '@material-ui/core';
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  icon: {
    display: 'flex', //Needed to center align
  },
  formControl: {
    //margin: theme.spacing(1.4),
    marginTop:15,
    minWidth:240,
  },
  lebelText:{
    fontSize:14,
    marginBottom:4
  },
  
}));